// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OAxt","type":"styles_type__3X67z","choices":"styles_choices__11kkB"};